<script>
import util from "@/libs/util";
export default {
  name: 'tian-map',
  props: {
    center: Array,
    show:{
      type:Boolean,
      default:false
    },
    isAddMarker:{
      type:Boolean,
      default:false
    }
  },
  watch:{
    show:{
      handler(newVal, oldVal) {
        console.log('show 发生变化', newVal,oldVal);
        if(newVal){
          this.loadMapScript()
        }else{
          this.destroyMap()
        }
      },
      deep: false, // 深度监听对象内部属性变化
      immediate: false // 初始化时立即执行一次
    }
  },
  data() {
    return {
      map: null, // 地图实例
      currentLabel:null,
      currentAddMarker:null,
      key: '61e9ee505078172d2ea9f7c7527be6e6', // 替换为你的密钥
      markers: [], // 存储所有标记点实例，便于后续销毁
      labels:[],
      pointList:[],
      zoom: 12 // 初始缩放级别
    }
  },
  mounted() {
    // this.loadMapScript()
  },
  beforeDestroy() {
    console.log("子组件被销毁beforeDestroy");
    this.destroyMap();
  },
  methods: {
    // 加载天地图脚本
    loadMapScript() {
      if (window.T) {
          this.initMap()
        return
      }

    },

    // 2025年10月28日 王欢  加载所有电梯位置坐标点
    loadAllDeviceMapMarkers(){
      util.ajax.get('/device/allMapMarkers').then(res => {
        this.pointList = res.data;
        // 初始化所有地图点
        this.addMarkers(this.pointList)
      })
    },

    // 初始化地图
    initMap() {
      this.loadAllDeviceMapMarkers();
      // 创建地图实例

      const container = this.$refs.mapContainer;
      console.log("容器是否存在:", !!container); // 应输出 true
      try{
      this.map = new window.T.Map('mapContainer', {
        projection: 'EPSG:4326' // 使用WGS84坐标系
      })

      // 设置地图中心点和缩放级别
      this.map.centerAndZoom(
          new window.T.LngLat(this.center[0], this.center[1]),
          this.zoom
      )
        console.log("初始化地图实例====>",this.map);
      // 添加地图控件
      this.addMapControls();

      // 监听地图事件
      this.bindMapEvents();
      }catch (e){
        console.log(e);
      }
      this.map.checkResize();

    },

    // 清除所有点
    clearMarkers(){
      if(this.map){
        this.markers.forEach(marker => {
          this.map.removeOverLay(marker)
        })
        this.markers = []
      }

    },
    hideCurrentAddMarker(){
      if (this.currentAddMarker) {
        this.map.removeOverLay(this.currentAddMarker) // 从地图移除
      }
      this.currentAddMarker = null;
    },
    // 显示label
    showLabel(lngLat,dname){

      // 1. 隐藏当前已显示的标注
      this.hideCurrentLabel()
      const label = new window.T.Label({
        text:dname,
        position: lngLat, // 标注位置（与标记点相同）
        offset: new window.T.Point(20, 0) // 文字偏移（避免遮挡标记点）
      })
      this.map.addOverLay(label)
      this.labels.push(label)
      this.currentLabel = label

    },

    // 隐藏label
    hideCurrentLabel(){
      if (this.currentLabel) {
        this.map.removeOverLay(this.currentLabel) // 从地图移除
        this.currentLabel = null // 清空记录
      }
    },

    // 清除所有标注对象
    clearLabels(){
      if(this.map){
        this.labels.forEach(label => {
          this.map.removeOverLay(label)
        })
        this.labels = []
      }
    },

    // 销毁地图
    destroyMap(){
      // 销毁地图实例，释放资源
      if (this.map) {
        this.clearMarkers() // 销毁前清除标记
        this.clearLabels();
        console.log(this.map);
        // this.map.closeInfoWindow();   // 销毁
        //  // 销毁
        let mapContainer = document.getElementById("mapContainer");
        let mapBox = document.getElementById("map-box");
        if(mapContainer) mapBox.removeChild(mapContainer);
        const newChildMapContainer = document.createElement("div");
        newChildMapContainer.id = "mapContainer";
        newChildMapContainer.className = "map-container";
        newChildMapContainer.style="width:100%;height:100%";
        mapBox.append(newChildMapContainer);
      }
      this.map = null;
    },

    // 添加地图控件
    addMapControls() {
      // 添加比例尺控件
      this.map.addControl(new window.T.Control.Scale())

      // 添加缩放控件
      this.map.addControl(new window.T.Control.Zoom())

      // 添加地图类型切换控件
      this.map.addControl(new window.T.Control.MapType({
        mapTypes: [
          window.TMAP_NORMAL_MAP,    // 标准地图
          // window.TMAP_SATELLITE_MAP, // 卫星地图
          // window.TMAP_TERRAIN_MAP    // 地形地图
        ]
      }))
    },

    // 绑定地图事件
     bindMapEvents() {
      // 地图点击事件
      this.map.addEventListener('click', (e) => {
        // console.log('点击位置经纬度：', e.lnglat.getLng(), e.lnglat.getLat())

      //   清除当前显示Label
          this.hideCurrentLabel();
          // console.log(this.isAddMarker);
      //   判断是否是添加点操作
        if(this.isAddMarker){
          let lng = e.lnglat.getLng();
          let lat = e.lnglat.getLat();
          const newLngLat = new window.T.LngLat(lng, lat)
          //  创建并添加标记点
          const newMarker = new window.T.Marker(newLngLat)
          this.hideCurrentAddMarker()
          this.map.addOverLay(newMarker)
          this.markers.push(newMarker);
          this.currentAddMarker = newMarker;
          const geocoder = new window.T.Geocoder();
          geocoder.getLocation(newLngLat, (data)=>{
            console.log('地址解析结果参数：',data);
            let status = data.status;
            let address = "";
            if(status === "0"){
              address = data.formatted_address;
            }
            this.$emit('onClickAdd',{lng,lat,address})
          });
        }
      })

      // 地图移动结束事件
      // this.map.addEventListener('moveend', () => {
      //   const center = this.map.getCenter()
      //   // console.log('当前中心点：', center.getLng(), center.getLat())
      // })
    },

    // 设置地图点
    // 批量添加标记点
    addMarkers(points) {
      if (!points.length || !this.map) return

      points.forEach(point => {
        // 校验经纬度格式
        if (!point.lng || !point.lat) return


        // 创建坐标对象
        const lngLat = new window.T.LngLat(point.lng, point.lat)
        const marker = new window.T.Marker(lngLat,{
          title:point.dname || this.$t("l.unknown_location")
        })
        // console.log(lngLat,marker);
        // 给标记点添加自定义信息（如名称）
        // marker.setName(point.dname || '未知地点')

        // 添加点击事件（可选）
        marker.addEventListener('click', () => {
          console.log("marker:", marker);
          this.showLabel(lngLat,"【"+point.dname+"】"+(point.address?point.address:this.$t("l.unset_elevator_address")));


        })

        // 添加到地图
        this.map.addOverLay(marker)
        // 存储标记点实例，便于后续清除
        this.markers.push(marker)
      })
    },

    // // 地图放大
    // zoomIn() {
    //   this.map.zoomIn()
    // },
    //
    // // 地图缩小
    // zoomOut() {
    //   this.map.zoomOut()
    // },
    //
    // // 重置地图
    // resetMap() {
    //   this.map.centerAndZoom(
    //       new window.T.LngLat(this.center[0], this.center[1]),
    //       this.zoom
    //   )
    // }
  }
}
</script>

<template>
  <div class="map-wrapper" id="map-box">
    <!-- 地图容器 -->
    <div id="mapContainer"  class="map-container"></div>

    <!-- 地图控制按钮 -->
<!--    <div class="map-actions">-->
<!--      <button @click="zoomIn" class="action-btn">放大</button>-->
<!--      <button @click="zoomOut" class="action-btn">缩小</button>-->
<!--      <button @click="resetMap" class="action-btn">重置</button>-->
<!--    </div>-->
  </div>
</template>

<style scoped>
.map-wrapper {
  position: relative;
  width: 100%;
  height: 750px;
}

#mapContainer {
  width: 100%;
  height: 100%;
}

.map-actions {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 100;
  display: flex;
  gap: 10px;
}

.action-btn {
  padding: 8px 12px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.action-btn:hover {
  background-color: #359e75;
}
</style>